var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendaricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 8.79482C1 5.70046 1 4.1533 1.96129 3.192C2.92258 2.23071 4.46975 2.23071 7.5641 2.23071H10.8462C13.9405 2.23071 15.4877 2.23071 16.4489 3.192C17.4103 4.1533 17.4103 5.70046 17.4103 8.79482V10.4358C17.4103 13.5302 17.4103 15.0774 16.4489 16.0386C15.4877 16.9999 13.9405 16.9999 10.8462 16.9999H7.5641C4.46975 16.9999 2.92258 16.9999 1.96129 16.0386C1 15.0774 1 13.5302 1 10.4358V8.79482Z",
    stroke: "#1C274C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.10352 2.23077V1",
    stroke: "#1C274C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.3086 2.23077V1",
    stroke: "#1C274C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.41016 6.33325H16.9999",
    stroke: "#1C274C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendaricon);
export default __webpack_public_path__ + "static/media/calendaricon.6802123762070057ba0d741d7bef2fb5.svg";
export { ForwardRef as ReactComponent };